<ng-container *transloco="let t">
  @if (!hideToolbar()) {
    <div class="header-toolbar d-flex justify-content-between">
      <div class="left">
        <a href="https://www.vinnova.se"
          ><lib-icon name="chevron-left" size="x-small"></lib-icon
          >{{ t('header_to_vinnova') }}</a
        >
      </div>
      <div class="right">
        @if (site === EtjansterSites.Ansok) {
          <a
            [href]="ansokanGuideUrl$ | async"
            target="_blank"
            class="ansokan-guide"
            ><lib-icon
              name="external-link"
              size="x-small"
              class="me-1"
            ></lib-icon
            >{{ t('header_application_guide') }}</a
          >
        }
        @if (authenticated()) {
          <a
            vinnova-button-text
            class="ms-3"
            href="{{ env.etjansterCommonUrl }}/public/fragor-och-svar"
          >
            <lib-icon name="help-circle" size="x-small" class="me-1"></lib-icon
            >{{ t('header_faq') }}
          </a>
        }
        <button vinnova-button-text class="ms-3" (click)="toggleLang()">
          <lib-icon name="globe" size="x-small" class="me-1"></lib-icon
          >{{ t('change_language') }}
        </button>
      </div>
    </div>
  }

  <div class="header-main">
    <nav>
      <div class="logo-container">
        @if (disableLogoLink()) {
          <div class="vinnova-logo-container">
            <img
              src="/assets/e-tjanster/vinnova-complete-green.svg"
              class="vinnova-logo"
              alt="vinnova logo"
            />
          </div>
        } @else {
          <a [href]="env.etjansterCommonUrl" class="vinnova-logo-container">
            <img
              src="/assets/e-tjanster/vinnova-complete-green.svg"
              class="vinnova-logo"
              alt="vinnova logo"
          /></a>
        }

        <span class="logo-title">{{ t('header_title_eservices') }}</span>
      </div>
      <ul class="nav-links d-none d-lg-flex">
        @for (link of links(); track $index) {
          <li class="nav-link" [class.active]="link.active">
            @if (link.active) {
              <button
                type="button"
                (click)="refreshPage()"
                style="cursor: pointer"
                aria-current="page"
                class="btn link-btn"
              >
                {{ t(link.name) }}
              </button>
            } @else if (
              (navigationService.ansokanGreenNotKlarmarkerad | async) ===
                false &&
              (navigationService.bedomareProfilInteSparad | async) === false
            ) {
              <a [attr.href]="link.url">{{ t(link.name) }}</a>
            } @else {
              <button vinnova-button-text (click)="navigate(link.url)">
                {{ t(link.name) }}
              </button>
            }
          </li>
        }
        @if (authenticated() && !hideLogout()) {
          <li class="nav-link logout d-flex align-items-center">
            @if (
              site() === EtjansterSites.Ansok ||
              site() === EtjansterSites.Projekt ||
              site() === EtjansterSites.Bedom
            ) {
              <a
                vinnova-button-secondary
                href="{{ env.etjansterCommonUrl }}/public/logout"
              >
                <lib-icon name="log-out" size="x-small" class="me-1"></lib-icon
                >{{ t('log_out') }}
              </a>
            }
            @if (
              site() === EtjansterSites.MinProfil ||
              site() === EtjansterSites.Start
            ) {
              <a vinnova-button-secondary routerLink="/public/logout">
                <lib-icon name="log-out" size="x-small" class="me-1"></lib-icon
                >{{ t('log_out') }}
              </a>
            }
          </li>
        }
      </ul>
      <ul class="d-lg-none nav-links">
        @if ((authenticated() && !hideLogout()) || links().length > 0) {
          <li class="nav-link">
            <button
              vinnova-button-text
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvas-mobile-nav"
              aria-controls="offcanvas-mobile-nav"
              aria-labelledby="offcanvas-menu-label"
            >
              @if (offCanvasMobileNavOpen) {
                <lib-icon name="x" size="small"></lib-icon>
              } @else {
                <lib-icon name="menu" size="small"></lib-icon>
              }
              <span class="menu-text ms-1" id="offcanvas-menu-label">{{
                t('menu')
              }}</span>
            </button>
          </li>
        }
      </ul>
      <div
        class="offcanvas offcanvas-end"
        id="offcanvas-mobile-nav"
        data-bs-backdrop="false"
        #offCanvasMobileNav
      >
        <ul>
          @for (link of links(); track $index) {
            <li>
              @if (link.active) {
                <a
                  routerLink="/"
                  aria-current="page"
                  data-bs-dismiss="offcanvas"
                  >{{ t(link.name) }}</a
                >
              } @else {
                <a [attr.href]="link.url">{{ t(link.name) }}</a>
              }
            </li>
          }
          @if (authenticated() && !hideLogout()) {
            <li>
              @if (
                site() === EtjansterSites.Ansok ||
                site() === EtjansterSites.Projekt ||
                site() === EtjansterSites.Bedom
              ) {
                <a href="{{ env.etjansterCommonUrl }}/public/logout">{{
                  t('log_out')
                }}</a>
              }
              @if (
                site() === EtjansterSites.Start ||
                site() === EtjansterSites.MinProfil
              ) {
                <a routerLink="public/logout">{{ t('log_out') }}</a>
              }
            </li>
          }
        </ul>
      </div>
    </nav>
  </div>
</ng-container>
